exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.options[data-v-2bbb1bf4]{position:absolute;top:0;z-index:1\n}\n.options.right-position[data-v-2bbb1bf4]{right:30px\n}\n.options.left-position[data-v-2bbb1bf4]{left:30px\n}\n.options .md-icon-button[data-v-2bbb1bf4]{padding:10px\n}\n.options .dropdown-menu li[data-v-2bbb1bf4]{cursor:pointer\n}\n.options .dropdown-menu li a[data-v-2bbb1bf4]{display:inline-block;width:100%\n}", ""]);

// exports
